<template>
    <div class="royal-experience-type">

        <ExperienceBanner 
            :initCategory="currentCategory"
            :onCategoryChange="onCategoryChange"
            :categories="categories"
        />

        <ShipExperience 
            class="royal-experience-content"
            :productModel="shipExperience.experienceItems || []"
            :cruiseRoyalExperienceItems="categories"
            :itemViewModels="shipExperience.itemViewModel||[]"
            :ships="ships"
            :initCategory="currentCategory"
            v-on:onCategoryChange="onCategoryChange"
        />

        <div class="rcclQN_recommend">
            <PromoCruise 
            :cruiseType='2'/>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShipExperiencePage"
}
</script>

<script>
const ShipExperience = () => import('@/components/Ship/ShipExperience')
const ExperienceBanner = () => import('@/components/Ship/ExperienceBanner')
const PromoCruise = () => import('@/components/Cruise/PromoCruise') 
export default {
    name: "ShipExperiencePage",
    components: {
        ShipExperience,
        ExperienceBanner,
        PromoCruise,
    },
    asyncData ({ store }) {
        return new Promise((resolve, reject) => {
            return store.dispatch('GET_SHIP_EXPERIENCE')
            .then(()=> {
                resolve();
            })
            .catch((e)=> {
                reject(e)
            })
        })
    },
    data () {
        return {
            currentCategory: ""
        }
    },
     beforeMount () {
        window.addEventListener('hashchange', this.initCurrentCategory)
    },
    beforeDestroy () {
        window.removeEventListener('hashchange', this.initCurrentCategory)
    },
    methods: {
        onCategoryChange (category) {
            this.currentCategory = category
        },
        initCurrentCategory () {
            
            if (this.categories.length > 0) {
                let menuIndex = 0
                let urlHash = this.$router.currentRoute.hash + ""
                if (urlHash && urlHash.length > 0) {
                    urlHash = urlHash.toLowerCase()
                    switch (urlHash) {
                        case "#food":
                            menuIndex = 0; break;
                        case "#room":
                            menuIndex = 1; break;
                        case "#activity":
                            menuIndex = 2; break;
                        case "#shopping":
                            menuIndex = 3; break;
                        case "#kid":
                            menuIndex = 5; break;
                        case "#entertainment":
                            menuIndex = 6; break;
                        default:
                            break;
                    }
                }
                if (menuIndex < this.categories.length) {
                    this.currentCategory = this.categories[menuIndex].category
                } else {
                    this.currentCategory = this.categories[0].category
                }
            }
        }
    },
    computed: {
        shipExperience () {
            return this.$store.state.page.shipExperience || {}
        },
        ships () {
            return this.shipExperience.ships || []
        },
        categories () {
            return this.shipExperience.cruiseRoyalExperienceItemList || []
        }
    },
    watch: {
        categories (newValue) {
            if (newValue && newValue.length > 0) {
                this.currentCategory = newValue[0].category || ""
            }
        }
    }
}
</script>

<style lang="less">
.royal-experience-type {
    min-width: 1300px;
    .rcclQN__experience {

        .experienceCon__title {
            display: none;
        }
        .experienceCon__menus {
            background: #f0f0f0;
            margin-top: 0px;
            .experienceCon__mainCon {
                margin: -65px auto 0;
                display: inline-block;
            }
        }

        .experienceTab--menus {
            width: 100%;
            height: 170px;
            min-width: 1024px;
            background: #f0f0f0;
            margin-top: -90px;
            padding-top: 90px;
        }

        .experienceCon__imgIntro {
            width: 100%;
            background: #f5f5f5;
            padding-top: 30px;
        }
        
    }

    .rcclQN_recommend {
        width: 100%;
        margin: 0px;
        padding-top: 20px;
        padding-bottom: 20px;
        background: #f5f5f5;
        .or_line_con {
            width: 1060px;
        }
    }
}
</style>